// extracted by mini-css-extract-plugin
module.exports = {"aboutHashiCorp":"style_aboutHashiCorp__r9XQs g-type-body-small","heading":"style_heading__2mzIU g-type-display-6"};